module.exports = __webpack_public_path__ + "img/75.6cbfd4c6.svg";